const ON_EVENT_REGEX = /^on[A-Z]/;

export function mergeProps<T extends Record<string, unknown>>(
  slotProps: T,
  childProps: Record<string, unknown>,
): Record<string, unknown> {
  const result: Record<string, unknown> = { ...slotProps };

  for (const key of Object.keys(childProps)) {
    const childValue = childProps[key];
    if (childValue === undefined) continue;

    const slotValue = result[key];

    if (key === 'className') {
      result[key] = [slotValue, childValue].filter(Boolean).join(' ').trim() || undefined;
      continue;
    }

    if (key === 'style') {
      result[key] = {
        ...(typeof slotValue === 'object' && slotValue !== null ? slotValue : {}),
        ...(typeof childValue === 'object' && childValue !== null ? childValue : {}),
      };
      continue;
    }

    if (ON_EVENT_REGEX.test(key) && typeof slotValue === 'function' && typeof childValue === 'function') {
      result[key] = (...args: unknown[]) => {
        (slotValue as (...a: unknown[]) => void)(...args);
        (childValue as (...a: unknown[]) => void)(...args);
      };
      continue;
    }

    result[key] = childValue;
  }

  return result;
}
